module.exports = __webpack_public_path__ + "media/cortina/slat-profile-05b8774f.png";